/**
 * Validation empty object
 * @param object
 * @returns boolean validation empty object
 */
export const objectEmpty = (object: any) => {
  return Object.keys(object).length === 0 && object.constructor === Object;
};
